import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useTheme } from "../../context/ThemeContext";

const Navbar = () => {
  const { theme, toggleTheme } = useTheme();
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  return (
    <header className="gf-header">
      <div className="gf-container gf-header__inner">
      <div className="gf-header__left">
        <button
          type="button"
          className="gf-header__menu-btn gf-only-mobile"
          aria-label="Open menu"
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen((o) => !o)}
        >
          ☰
        </button>
        <Link to="/" className="gf-logo" onClick={() => setMenuOpen(false)}>
          <img
            src={theme === "dark" ? "/aw-white.png" : "/aw-blue.png"}
            alt="ADNWEBS"
            className="gf-logo__img"
          />
        </Link>
      </div>

      <div className="gf-header__center gf-only-desktop">
        {location.pathname === "/" && (
          <span className="gf-header__tagline">Developer discovery</span>
        )}
      </div>

      <div className="gf-header__right">
        <nav className={`gf-header__nav ${menuOpen ? "is-open" : ""}`} aria-label="Main">
          <Link to="/" onClick={() => setMenuOpen(false)}>
            Home
          </Link>
          <Link to="/guide" onClick={() => setMenuOpen(false)}>
            Guides
          </Link>
          <Link to="/about" onClick={() => setMenuOpen(false)}>
            About
          </Link>
          <a
            href="https://github.com"
            target="_blank"
            rel="noopener noreferrer"
            className="gf-header__gh"
          >
            GitHub
          </a>
        </nav>
        <button
          type="button"
          className="gf-btn gf-btn--ghost gf-header__theme"
          onClick={() => toggleTheme()}
          aria-label={theme === "dark" ? "Switch to light mode" : "Switch to dark mode"}
        >
          {theme === "dark" ? "☀️" : "🌙"}
        </button>
      </div>
      </div>

      {menuOpen && (
        <button
          type="button"
          className="gf-header__overlay gf-only-mobile"
          aria-label="Close menu"
          onClick={() => setMenuOpen(false)}
        />
      )}
    </header>
  );
};

export default Navbar;
